import React, { useState } from "react";
import { Modal, Input, Row, Col, Typography, notification } from "antd";
import euroIcon from "../../assets/icons/pooling/euroCurrency.svg";
import { useSelector } from "react-redux";
const { Text } = Typography;

const FinalSettlePriceModal = ({ isVisible, handleInitiatePool, handleFinalSettlePriceModalClose }) => {
  const [inputValue, setInputValue] = useState('');
  const [brokerPercentage, setBrokerPercentage] = useState('');
  const [brokerError, setBrokerError] = useState('');
  const [finalSettlementError, setFinalSettlementError] = useState('');
  const { user } = useSelector((state) => state.user);

  const handleOk = () => {
    const parsedValue = parseFloat(inputValue);
    const parsedBrokerPercentage = parseFloat(brokerPercentage);
    const parsedinputValue = parseFloat(inputValue);
    console.log("yes ok");
    if (!inputValue || isNaN(parsedValue) || parsedValue <= 0) {
      notification.error({
        message: 'Invalid Input',
        description: 'Please enter a valid positive price.',
        placement: 'topRight',
      });
      return;
    }

    if (user.role === "Admin Pooling Agent") {
      if (isNaN(parsedBrokerPercentage) || parsedBrokerPercentage < 0 || parsedBrokerPercentage > 100) {
        setBrokerError('Broker percentage must be between 0 and 100.');
        return;
      }
      setBrokerError('');
    }

    if (user.role === "Admin Pooling Agent") {
      if (isNaN(parsedinputValue) || parsedinputValue < 0) {
        setFinalSettlementError('Final Settlement Price cannot be negative or alphabets.');
        return;
      }
      setFinalSettlementError('');
    }
    

    handleInitiatePool(parsedValue, user.role === "Admin Pooling Agent" ? parsedBrokerPercentage : null);
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/-/g, '');
    setInputValue(value);
    if (value !== "" && (isNaN(value) || parseFloat(value) < 0)) {
      setFinalSettlementError('Final Settlement Price cannot be negative or alphabets.');
    } else {
      setFinalSettlementError('');
    }

  };

  const handleBrokerChange = (e) => {
    const value = e.target.value.replace(/-/g, '');
    setBrokerPercentage(value);
    if (value !== "" && (isNaN(value) || parseFloat(value) < 0 || parseFloat(value) > 100)) {
      setBrokerError('Broker percentage must be between 0 and 100.');
    } else {
      setBrokerError('');
    }
  };

  return (
    <Modal
      open={isVisible}
      onCancel={handleFinalSettlePriceModalClose}
      onOk={handleOk}
      width="25vw" 
      centered
      className="final-settle-price-modal z-1000 bg-white"
    >
      <Row>
        <Col>
          <Text style={{fontSize:'2vh'}} strong>Final Settlement Price</Text>
          <Input
            className="final-settlement-price"
            addonAfter={<div style={{ fontSize:'2vh' }}>€/MT CO<sub>2</sub>e</div>}
            value={inputValue}
            min={0}
            onChange={handleInputChange}
            type="number"
            step="0.01"
          />
          {finalSettlementError && <Text type="danger">{finalSettlementError}</Text>}

        </Col>
      </Row>
      {user.role === "Admin Pooling Agent" && (
        <Row style={{ marginTop: 16 }}>
          <Col>
            <Text style={{fontSize:'2vh'}} strong>Brokerage</Text>
            <Input
              className="broker-percentage"
              addonAfter={<span style={{ fontSize: '2vh', marginRight: 5 }} >%</span>}
              value={brokerPercentage}
              min={0}
              style={{width:"22.5vw",height:"5vh"}}
              onChange={handleBrokerChange}
              type="number"
              step="0.01"
            />
            {brokerError && <Text type="danger">{brokerError}</Text>}
          </Col>
        </Row>
      )}
    </Modal>
  );
};

export default FinalSettlePriceModal;
